import trimString from './trimString';
export default trimString;